/**
 * Aspid / product: галерея, выбор вариации (цена, артикул, наличие,
 * кнопки корзины), вкладки, отзывы через /ajax/review/list, "купить
 * сейчас" (в корзину и на чекаут).
 */
import { initGallery } from './modules/gallery';

const { api, t, price, notify, cart } = window.rt;

const app = document.getElementById('productApp');

if( app ) {

    initGallery( app );

    const variations = JSON.parse( app.dataset.variations || '[]' );
    const productId  = Number( app.dataset.productId );

    let current = variations.find( v => v.id === Number( app.dataset.variationId ) ) || variations[0] || null;

    // --- галерея ---

    const mainImg = app.querySelector('[data-gallery-main]');

    app.querySelector('[data-gallery-thumbs]')?.addEventListener( 'click', ( event ) => {

        const thumb = event.target.closest('.gallery-thumb');

        if( ! thumb )
            return;

        app.querySelectorAll('.gallery-thumb').forEach( el => el.classList.remove('active') );
        thumb.classList.add('active');

        if( thumb.dataset.galleryImage && mainImg )
            mainImg.src = thumb.dataset.galleryImage;

        if( thumb.dataset.galleryVideo )
            window.open( thumb.dataset.galleryVideo, '_blank', 'noopener' );
    } );

    // --- вариации ---

    function applyVariation( variation ) {

        current = variation;

        const cost = variation.sale_price > 0 ? variation.sale_price : variation.price;

        const priceEl = app.querySelector('[data-price]');
        const oldEl   = app.querySelector('[data-old-price]');
        const skuEl   = app.querySelector('[data-sku]');
        const stockEl = app.querySelector('[data-stock]');

        if( priceEl )
            priceEl.innerHTML = price( cost, false ) + '<small>' + window.shop.currencySuffix + '</small>';

        if( oldEl ) {
            oldEl.hidden      = ! ( variation.sale_price > 0 );
            oldEl.textContent = price( variation.price );
        }

        if( skuEl )
            skuEl.textContent = variation.sku || '';

        if( stockEl ) {
            stockEl.textContent = variation.stock > 0 || variation.stock === -1 ? t('common.in_stock')
                : ( variation.stock === -2 ? t('common.made_to_order') : t('common.out_of_stock') );
            stockEl.classList.toggle( 'in-stock', variation.stock > 0 || variation.stock === -1 );
            stockEl.classList.toggle( 'on-order', variation.stock === -2 );
        }

        const leadTime = app.querySelector('[data-lead-time]');

        if( leadTime ) {
            leadTime.hidden = variation.stock !== -2 || ! variation.lead_time;
            leadTime.textContent = variation.lead_time || '';
        }

        app.querySelectorAll('[data-action="cart-add"], [data-action="buy-now"]').forEach( ( btn ) => {
            btn.dataset.variationId = variation.id;
            btn.disabled = variation.stock === 0;
        } );

        if( variation.image?.sizes?.full && mainImg )
            mainImg.src = variation.image.sizes.full;

        const url = new URL( location.href );

        if( variation.is_default )
            url.searchParams.delete('v');
        else
            url.searchParams.set( 'v', variation.id );

        history.replaceState( null, '', url.toString() );
    }

    app.querySelector('[data-variation-options]')?.addEventListener( 'click', ( event ) => {

        const opt = event.target.closest('[data-variation]');

        if( ! opt )
            return;

        const variation = variations.find( v => v.id === Number( opt.dataset.variation ) );

        if( ! variation )
            return;

        app.querySelectorAll('.variation-opt').forEach( el => el.classList.remove('active') );
        opt.classList.add('active');

        applyVariation( variation );
    } );

    // --- вкладки и купить сейчас ---

    function switchTab( name ) {

        app.querySelectorAll('.tab-btn').forEach( el => el.classList.toggle( 'active', el.dataset.tab === name ) );
        app.querySelectorAll('.tab-content').forEach( el => el.classList.toggle( 'active', el.id === 'tab-' + name ) );

        if( name === 'reviews' )
            loadReviews( 1 );
    }

    app.addEventListener( 'click', async ( event ) => {

        const el = event.target.closest('[data-action]');

        if( ! el )
            return;

        if( el.dataset.action === 'tab' ) {
            event.preventDefault();
            switchTab( el.dataset.tab );
        }

        if( el.dataset.action === 'buy-now' ) {

            el.disabled = true;

            try {
                await cart.add( productId, Number( el.dataset.variationId ), 1 );
                location.href = window.baseURL + '/checkout';
            } catch( e ) {
                notify( e.message, 'error' );
                el.disabled = false;
            }
        }

        if( el.dataset.action === 'review-more' )
            loadReviews( reviews.page + 1, true );
    } );

    // --- отзывы ---

    const reviews = { page: 0, pages: 0, loaded: false };

    function escape( text ) {

        return String( text ).replace( /[&<>"']/g, ch => ( {
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
        } )[ ch ] );
    }

    function stars( n ) {

        let out = '<div class="stars">';

        for( let i = 1; i <= 5; i++ )
            out += `<svg class="${ i <= n ? 'star-filled' : 'star-empty' }" viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>`;

        return out + '</div>';
    }

    function initials( name ) {

        return name.split(' ').filter( Boolean ).slice( 0, 2 ).map( p => p[0].toUpperCase() ).join('');
    }

    async function loadReviews( page, append = false ) {

        const list    = app.querySelector('[data-reviews-list]');
        const summary = app.querySelector('[data-reviews-summary]');
        const more    = app.querySelector('[data-action="review-more"]');

        if( ! list || ( reviews.loaded && ! append ) )
            return;

        try {

            const data = await api.post( 'review/list', { product_id: productId, page, page_size: 10 } );

            reviews.page   = data.page;
            reviews.pages  = data.pages;
            reviews.loaded = true;

            const html = data.items.map( r => `
                <div class="review-item">
                    <div class="review-header">
                        <div class="review-author">
                            <div class="review-avatar">${ escape( initials( r.author_name || '?' ) ) }</div>
                            <div class="review-name">${ escape( r.author_name ) }${ r.flag ? `<small>${ escape( r.flag ) }</small>` : '' }</div>
                        </div>
                        <div class="review-date">${ escape( r.created_at.slice( 0, 10 ) ) }</div>
                    </div>
                    ${ stars( r.star ) }
                    <div class="review-text">${ escape( r.content ) }</div>
                    ${ r.images.length ? `<div class="review-images">${ r.images.map( src => `<img src="${ escape( src ) }" alt="" loading="lazy">` ).join('') }</div>` : '' }
                </div>` ).join('');

            if( append )
                list.insertAdjacentHTML( 'beforeend', html );
            else
                list.innerHTML = html || `<p class="acc-message">${ t('product.no_reviews') }</p>`;

            if( summary && data.summary && data.summary.count > 0 ) {

                const dist = data.summary.dist;
                const max  = Math.max( 1, data.summary.count );

                summary.hidden = false;
                summary.innerHTML = `
                    <div>
                        <div class="reviews-big-num">${ data.summary.rating }</div>
                        <div class="reviews-big-sub">${ stars( Math.round( data.summary.rating ) ) }<span>${ t( 'product.based_on', { n: data.summary.count } ) }</span></div>
                    </div>
                    <div class="reviews-bars">
                        ${ [ 5, 4, 3, 2, 1 ].map( s => `
                            <div class="review-bar-row"><span>${ s }</span><div class="review-bar"><div class="review-bar-fill" style="width:${ Math.round( dist[ s ] / max * 100 ) }%"></div></div><span>${ dist[ s ] }</span></div>` ).join('') }
                    </div>`;
            }

            if( more )
                more.hidden = reviews.page >= reviews.pages;

        } catch( e ) {
            notify( e.message, 'error' );
        }
    }

    if( location.hash === '#reviews' )
        switchTab('reviews');
}
